import { useCallback } from 'react';
import styles from './deleteModal.module.scss';
import Modal from '@components/modal/Modal';
import Button from '@components/button/Button';

type Props = {
  open?: boolean;
  loading?: boolean;
  onClose?: () => void;
  onDelete?: () => void;
  message?: string;
  cancelLabel?: string;
  deleteLabel?: string;
  size?: 'normal' | 'small';
};

function DeleteModal(props: Props) {
  const { open, loading, onClose, onDelete, message, cancelLabel, deleteLabel, size } = props;

  const handleClose = useCallback(() => {
    onClose?.();
  }, [onClose]);

  const handleDelete = useCallback(() => {
    onDelete?.();
  }, [onDelete]);

  return (
    <Modal open={!!open} onClose={handleClose} closeButton={false} className={[styles.wrapper, size === 'small' ? styles.small : '' ].join(' ')}>
      <div>
        <div className={styles.title}>{message}</div>
          <div className={styles.content}>
            <div className={styles.action}>
              <Button className={styles.cancelButton} disabled={loading} onClick={handleClose} label={cancelLabel ? cancelLabel : 'CANCEL'}/>
              <Button className={styles.deleteButton} disabled={loading} isLoading={loading} onClick={handleDelete} label={deleteLabel ? deleteLabel : 'CONFIRM DELETION'}/>
            </div>
          </div>
      </div>
    </Modal>
  );
}

export default DeleteModal;
